import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CreditoPersonal from "../pages/credito-personal/page";
import CreditoPyme from "../pages/credito-pyme/page";
import Distribuidor from "../pages/conviertete-en-distribuidor/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/credito-personal", element: <CreditoPersonal /> },
  { path: "/credito-pyme", element: <CreditoPyme /> },
  { path: "/conviertete-en-distribuidor", element: <Distribuidor /> },
  { path: "*", element: <NotFound /> }, // catch-all para rutas inexistentes
];

export default routes;